const choo = require('choo')
const bendingView = require('./views/bend.js')
const TutorialView = require('./views/tutorial-view.js')
const browserView = require('./views/scaffold-project-browser.js')
const store = require('./store.js')
const app = choo({ hash: true })
window.app = app
app.use(store)
app.route('/bend/:project_id', bendingView)
app.route('/tutorial/:project_id', TutorialView)
app.route('/', browserView)
app.mount('#app')
